import {StorageDbService} from './storage-db';

export * from './storage-db';

export const storageDbProviders = [
  StorageDbService
];
